<template>
    <div>
        <div style="width: 100%;margin-bottom: 20px;">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>售后管理列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <!-- 搜索筛选 -->
        <!-- 搜索筛选 -->
        <el-card class="box-card" style="margin-bottom: 20px;">
            <el-form :inline="true" class="user-search" :model="formInline">
                <el-form-item label="订单编号：">
                    <el-input size="small" placeholder="请输入订单编号" v-model="formInline.orderNo" clearable></el-input>
                </el-form-item>
                <el-form-item label="退款编号">
                    <el-input size="small" placeholder="请输入商品名称" v-model="formInline.refundNo" clearable></el-input>
                </el-form-item>
                <el-form-item label="买家手机">
                    <el-input size="small" placeholder="买家手机号" v-model="formInline.phone" clearable></el-input>
                </el-form-item>
                
                <el-form-item label="申请时间">
                   
                    <datapicker @click="changetime1"  :startTime="formInline.applyStart" :endTime="formInline.endTime"></datapicker>
                </el-form-item>
                <el-form-item label="退款状态" >
                    <el-select v-model="refundStatuss" placeholder="请选择"  @change="changeStatus1" clearable>
                        <el-option :label="item.name" :value='item.id' v-for="item in refundStatusList" :key="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="订单状态" >
                    <el-select v-model="status" placeholder="请选择" multiple @change="changeStatus" clearable>
    
                        <el-option label="待付款" value='nopay'></el-option>
                        <el-option label="待发货" value='nosend'></el-option>
                        <el-option label="待收货" value='norecevied'></el-option>
                        <el-option label="待评价" value='finished'></el-option>
                        <el-option label="已完成" value='haverecived'></el-option>
                        <el-option label="已取消" value='cancel'></el-option>
                        <el-option label="已关闭" value='close'></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="售后">
                    <el-select v-model="formInline.afterSaleStatus" placeholder="请选择" clearable>
                        <el-option label="未申请售后" value="0"></el-option>
                        <el-option label="处理退款中" value="1"></el-option>
                        <el-option label="售后完成" value="2"></el-option>
    
                    </el-select>
                </el-form-item>
                <el-form-item label="支付方式">
                    <el-select v-model="formInline.payType" placeholder="请选择" clearable>
                        <el-option :label="item.name" :value="item.value" v-for="item in payTypeList" :key="item.value"></el-option>
    
                    </el-select>
                </el-form-item>
    
                <el-form-item>
                    <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                    <!-- <el-button size="small" type="warning" icon="el-icon-delete" @click="clear">清空刷选条件</el-button> -->
                    <!-- <el-button size="small" type="danger" @click="postopen">批量发货</el-button> -->
                </el-form-item>
            </el-form>
        </el-card>

        <!--列表-->
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
            element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column sortable prop="orderId" label="更多" width="50" align="center" type="expand" >
                <template slot-scope="scope">
                    <el-row :gutter="20" >
                        <el-col :span="6">
                            <div class="demo-detail">订单编号:{{scope.row.order.orderSn }}</div>
                        </el-col>
                        <el-col :span="6">
                            <div  class="demo-detail">退款编号:{{scope.row.refundsn }}</div>
                        </el-col>
                        <el-col :span="6">
                            <div  class="demo-detail">收货人:{{scope.row.order.name }}</div>
                        </el-col>
                        <el-col :span="6">
                            <div  class="demo-detail">收货地址:{{scope.row.order.address }}</div>
                        </el-col>
                        <el-col :span="6">
                            <div  class="demo-detail">订单状态:{{web.fomatOrderStatus(scope.row.order.orderStatus) }}</div>
                        </el-col>
                        
                        <el-col :span="6">
                            <div  class="demo-detail">退款原因:{{scope.row.refundReason }}</div>
                        </el-col>
                        <el-col :span="6">
                            <div  class="demo-detail">退款物流单号:{{scope.row.expressNumber }}</div>
                        </el-col>
                        <el-col :span="6">
                            <div  class="demo-detail">退款物流公司:{{scope.row.expressCompany }}</div>
                        </el-col>
                    </el-row>   
                  </template>
            </el-table-column>
            <el-table-column  label="商品信息" min-width="230" align="center">
                <template slot-scope="scope">
                  <div >
                    <span v-for="(item,index) in scope.row.orderGoodsList" :key="index" style="margin-right: 10px;display: flex;margin-bottom: 10px;">
                        <el-image style="width: 60px; height: 60px" :src="item.goodsImg"></el-image>
                        <div class="line1"  style="width: 140px;">
                            <div>{{item.goodsName}}</div>
                            <span style="color: red;">{{item.unitPrice}}</span>  *{{item.buyNum}}</div>
                  
                    </span>
                </div>
                </template>
            </el-table-column>
            <el-table-column label="订单状态" width="150" align="center">
                <template slot-scope="scope">
                    <div >{{web.fomatOrderStatus(scope.row.order.orderStatus)}}</div>
                </template>
            </el-table-column>
            <el-table-column  label="订单金额" width="150" align="center">
                <template slot-scope="scope">
                    <div >{{scope.row.order.payAmount}}</div>
                </template>
            </el-table-column>
            <el-table-column sortable prop="name" label="退款金额" width="150" align="center">
                <template slot-scope="scope">
                    <div >{{scope.row.order.payAmount}}</div>
                </template>
            </el-table-column>
            <el-table-column  prop="name" label="申请时间" width="150" align="center">
                <template slot-scope="scope">
                    <div >{{web.formatTime(scope.row.createTime,'Y-M-D h:m')}}</div>
                </template>
            </el-table-column>
            <el-table-column sortable prop="name" label="用户信息" width="150" align="center">
                <template slot-scope="scope">
                    <el-image style="width: 60px; height: 60px" :src="scope.row.user.face"></el-image>
                    <div>
                        <el-link type="primary" @click="touserDetail(scope.row.user)">{{scope.row.user.username}}</el-link>
                    </div>  
                    <div >{{scope.row.user.mobile}}</div>
                </template>
            </el-table-column>
            <el-table-column sortable prop="name" label="下单时间" width="150" align="center"> 
                <template slot-scope="scope">
                    <div >{{web.formatTime(scope.row.order.createTime,'Y-M-D h:m')}}</div>
                </template>
            </el-table-column>
            <el-table-column  label="退款状态" width="150" align="center">
                <template slot-scope="scope">
                    <div >{{formatStatus(scope.row.isRefund)}}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" min-width="300">
                <template slot-scope="scope" v-if="scope.row.isRefund==1">
                    <el-button  size="mini"  type="danger" @click="Consent( scope.row)">同意</el-button>
                    <el-button  size="mini"  type="danger" @click="afterSaleCloseApply( scope.row)">关闭</el-button>
                    <el-button  size="mini"  type="danger" @click="afterSaleRejectApply( scope.row)">拒绝</el-button>
                    <!-- <el-button  size="mini"  type="danger" icon="el-icon-delete" @click="handledelete( scope.row)">删除</el-button> -->       
                </template>
            </el-table-column>
        </el-table>
          <!-- 分页组件 -->
          <Pagination :child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 弹框 设代理和设置会员-->
       <el-dialog
      :close-on-click-modal="false"
        title="设置"
        :visible.sync="dialogVisible"
        width="30%"
        >
        <el-form>
           
            
            <el-form-item label="标签名字" >
               <el-input v-model="name"></el-input>
                
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <!-- <el-button type="primary" @click="addEditTag" >设置</el-button> -->
         
        </span>
      </el-dialog>


    </div>
</template>

<script>
    
// 售后查询           售后详情查询                  同意售后申请               关闭售后申请          拒绝售后申请
// afterSaleAppList , getAfterSaleApplyDetailInfo , afterSaleConsentApply , afterSaleCloseApply , afterSaleRejectApply
    import {  afterSaleApplyList  , afterSaleConsentApply ,afterSaleCloseApply , afterSaleRejectApply} from '../../api/basisMG.js'
 
    // 导出模块
    export default {
        
        // 模块数据
        data() {
            //数据  
            return {       
                loading: true,
                visible: false,
                listData: [],          
                dialogVisible: false,
                tagId:'',
                name:'',
                formInline: {
                    start: 0,
                    length: 5,
                   
                },
                time1:[],
                status:[],
                // 分页参数
                pageparm: {
                    currentPage: 1,
                    pageSize: 5,
                    total: 10,
                    start: 0,
                    length: 5
                },
                refundStatuss:null,
                refundStatusList:[
                    {id:1,name:'申请退款'},
                    // {id:2,name:'同意退款'},
                    {id:3,name:'拒绝退款'},
                    {id:4,name:'卖家驳回申请'},
                    {id:5,name:'退款成功'},
                    // {id:6,name:'退款成待卖家收货'},
                    {id:7,name:'订单取消'},
                // 1/申请退款、2/同意退款、3/拒绝退款,4卖家驳回申请,5退款成功，6待卖家收货，7订单取消
                ],
                payTypeList:[
				
					{name:'支付宝',value:'alipay'},
					{name:'银盛银联云闪付',value:'ysUnionPay'},
					{name:'微信支付',value:'wxpay'},
					{name:'余额支付',value:'zeropay'},

				]
            }
        },


        watch: {},

        methods: {
             // 查询
            //  search() {
            //     this.formInline.start = 0
			// 	this.pageparm.currentPage = 1
            //     this.getdata(this.formInline)
            // },
            changeStatus(val){
                console.log(val)
                if(val && val.length){
                    this.formInline.orderStatuss = val.join(",")
                }else{
                    this.formInline.orderStatuss = ""
                }
              
            },
            changeStatus1(val){
               
                if(val ){
                    this.formInline.refundStatus = val
                }else{
                    this.formInline.refundStatus = ""
                }
                console.log( this.formInline)
            },
            changetime1(val){
                if(val.length){
                    this.formInline.applyStart = val[0]
                    this.formInline.endTime = val[1]
                }else{
                    this.formInline.applyStart = ""
                    this.formInline.endTime = ""
                }
            },
            
            formatStatus(val){
             
                let res = this.refundStatusList.find(item=>{
                  
                    if(val==item.id){
                       
                        return item
                    }
                })
              
                return res.name
            },
            touserDetail(row){
                this.$router.push({path:'/user/userDetail',query: {uid: row.uid}})
            },
            showPop(){
                this.visible = true
                console.log(111)
            },
            // 获得用户数据
            getdata() {
                this.afterSaleAppList() 
            },
            // 获得所有用户标签
            afterSaleAppList(){
                let param = this.formInline
                afterSaleApplyList(param).then(res=>{
                    this.saveParams(this.$route.path,param)
                    if (res.code == '200') {
                        this.listData = res.data.content
                        console.log(this.listData)
                        this.loading = false
                        this.pageparm.total = res.data.totalElements
                    }
                })
            },
            //   // 分页插件事件
            //   callFather(parm) {
            //     this.pageparm.currentPage  = parm.currentPage
            //     this.pageparm.pageSize =  parm.pageSize 
            //     this.pageparm.start  = parm.currentPage - 1
            //     this.pageparm.length =  parm.pageSize 
            //     this.formInline.start = parm.currentPage - 1
            //     this.formInline.length = parm.pageSize
            //     this.getdata(this.formInline)
            // },
            Consent(row){
            
                let msg = '确认同意'+ row.user.username + '的售后申请?'
                this.$confirm(msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                this.afterSaleConsentApply(row)
                })
            },
            // 同意售后申请
            afterSaleConsentApply(row){
                
                afterSaleConsentApply({afterSaleApplyId:row.id}).then(res=>{
              
                    if (res.code == '200') {
                        this.$message({ 
                            type: 'success',
                            message:'处理成功'
                        })
                        this.getdata()
                        this.visible = false
                    }else{
                        // this.$message.error(res.message)
                    }
                })
            },
          
            handleedit(row){
                this.name = row.name 
                this.tagId = row.tagId
                this.dialogVisible = true
            },
            add() {
                this.name = ""
              this.dialogVisible = true
            },
            // 关闭退款申请
            afterSaleCloseApply(row){
                let msg = '确认关闭'+ row.user.username + '的售后申请?'
                this.$confirm(msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    
                    afterSaleCloseApply({afterSaleApplyId:row.id}).then(res => {
                    if (res.code == '200') {
                        this.$message({ 
                            type: 'success',
                            message:'设置成功'
                        })
                        this.getdata()
                        this.dialogVisible = false
                        
                    }else{
                        // this.$message.error(res.message)
                    }
                })

                })
               
            },
             // 拒绝退款申请
             afterSaleRejectApply(row){
                let msg = '确认拒绝'+ row.user.username + '的售后申请?'
                this.$confirm(msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    
                    afterSaleRejectApply({afterSaleApplyId:row.id}).then(res => {
                    if (res.code == '200') {
                        this.$message({ 
                            type: 'success',
                            message:'设置成功'
                        })
                        this.getdata()
                        this.dialogVisible = false
                        
                    }else{
                        // this.$message.error(res.message)
                    }
                })

                })
               
            },
        },
        // 创建前状态(里面是操作)
        beforeCreate() { },
        // 创建完毕状态(里面是操作)
        created() {
            this.getParams(this.$route.path)
            if(this.formInline.refundStatus){
                this.refundStatuss=this.formInline.refundStatus
            }
            if(this.formInline.orderStatuss){
                this.status= this.formInline.orderStatuss.split(",")
            }
            this.getdata() 
              
        },
        // 挂载前状态(里面是操作)
        beforeMount() { },
        // 挂载结束状态(里面是操作)
        mounted() { },
        // 更新前状态(里面是操作)
        beforeUpdate() { },
        // 更新完成状态(里面是操作)
        updated() { },
        // 销毁前状态(里面是操作)
        beforeDestroy() { },
        // 销毁完成状态(里面是操作)
        destroyed() { }
    };
</script>

<style scoped>
    .el-form-item {
      
        box-sizing: border-box;
    }

    .just-start {
        display: flex;
        justify-content: flex-start;
    }

    .marginT20 {
        margin-top: 20px;
    }
</style>